<template>
  <div class="text-image" :class="[bgColorClass, sectionOrientationClass]">
    <div class="text-image__content" :class="[contentAlignClass, contentFlowClass]">
      <div class="text-image__text-flow" :class="[textAlignmentClass]">
        <div class="text-image__header" v-if="heading">
          <BaseHeading :size="1">{{heading}}</BaseHeading>
        </div>
        <div
          v-for="(item, n) in textList"
          :key="n"
          class="text-image__paragraph">
          <BaseText><p v-html="item"></p></BaseText>
        </div>
      </div>
      <div
        v-if="image"
        class="text-image__image-wrapper"
        :class="[imageAlignClass]">
        <div class="text-image__image" :class="[imageOrientationClass]">
          <ModuleImage :imageUrl="image" :placeholderUrl="placeholderImage"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SectionTextImage',
  props: {
    image: String,
    heading: String,
    textList: Array,
    alignment: String,
    bgColor: String,
    imageOrientation: {
      type: String,
      default: 'landscape'
    },
    contentFlow: String
  },
  computed: {
    contentAlignClass: function () {
      return this.alignment === 'right' ? 'text-image__content--align-right' : 'text-image__content--align-left'
    },
    textAlignmentClass: function () {
      return this.alignment === 'right' ? 'text-image__text-flow--align-right' : null
    },
    imageAlignClass: function () {
      return this.alignment === 'right' ? 'text-image__image-wrapper--align-left' : null
    },
    bgColorClass: function () {
      return this.bgColor ? `text-image--bg-color-${this.bgColor}` : null
    },
    imageOrientationClass: function () {
      return `text-image__image--orientation-${this.imageOrientation}`
    },
    sectionOrientationClass: function () {
      return `text-image--orientation-${this.imageOrientation}`
    },
    contentFlowClass: function () {
      return this.contentFlow ? `text-image__content--content-flow-${this.contentFlow}` : null
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './section-text-image'
</style>



// WEBPACK FOOTER //
// src/components/SectionTextImage/SectionTextImage.vue